import { fromJS } from 'immutable';
import { START, SUCCESS, ERROR, SHOW, HIDE } from '../../consts';
import { FORM, MODAL, USER_LOGIN, USER_REGISTER } from './actionTypes';

const DEFAULT_STATE = fromJS({
  formShow: false,
  process: false,
  formType: 'signin',
  error: null,
  modalShow: false,
  modalText: ''
});

export default function search (state = DEFAULT_STATE, action) {
  switch (action.type) {
    case FORM + SHOW:
      return state.merge({
        formShow: true,
        formType: action.formType
      });
    case FORM + HIDE:
      return state.set('formShow', false);

    case MODAL + SHOW:
      return state.merge({
        modalShow: true,
        modalText: action.message
      });
    case MODAL + HIDE:
      return state.set('modalShow', false);

    case USER_LOGIN + START:
    case USER_REGISTER + START:
      return state.merge({
        process: true,
        error: null
      });

    case USER_LOGIN + SUCCESS:
    case USER_REGISTER + SUCCESS:
      return state.merge({
        process: false,
        formType: action.formType,
        error: null
      });

    case USER_LOGIN + ERROR:
    case USER_REGISTER + ERROR:
      return state.merge({
        process: false,
        formType: action.formType,
        error: action.payload
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/Auth/reducer.js